/**
 * drugInDevice is the same thing to DrugStorage in the backend.
 * (I should name them as the same variable name through...)
 * 處理所有跟藥倉相關的流程及資料
 */
import _ from 'lodash';
import moment from 'moment';
import * as Mutations from '../mutation-types';

const state = {
  selectedDrugInDevice: {},                 // 選擇到的藥倉資料們
  selectedDrugInDeviceID: [],               // 選擇到的藥倉Ids
  allDrugInDevice: {},                      // 所有藥倉
  // other types of drugInDevices
  expiredDrugInDevice: [],                  // 過期的藥倉
  drugInDeviceLowStockList: [],             // 低於安全存量的藥倉
  RefillDrugInDeviceList: [],               // 補藥清單內的藥倉
  //
  sortedSelectedDrugInDevice: [],           // 排序過的選擇藥倉清單
  sortedSelectedDrugInDeviceIndex: 0,       // 目前操作的藥倉index (在排序過的選擇藥倉清單中)
  currentDrugInDevice: null,                // 目前操作的藥倉
  currentDrugInDeviceIndex: 0,              // 目前操作的藥倉index (在排序過得選擇藥倉清單中)
  nextDrugInDevice: null,                   // 下一步驟操作的藥倉
  drugInDeviceList: [],                     // 原始的藥倉清單
  copyDrugInDeviceList: [],                 // 複製的藥倉清單
  filterDrugInDeviceList: [],               // 篩選過後的藥倉清單
  //
  DrugStorageWithSameDrug: {},              // 同種藥物的藥倉們
  DrugStorageWithSameDrugID: [],            // 同種藥物的藥倉ids
  expiredDrugCount: 0,                      // 過期的藥倉數量
  graduallyExpiredDrugCount: 0,             // 即期的藥倉清單
  storageErrorCount: 0,                     // 存量不符數量
  storageError: [],                         // 存量不符事件
  //
  drugStorageChangedId: undefined,          // 於前台改變的藥倉
  drugStorageChangedTime: 0,                // 藥倉改變的次數
  hasUsedDrugStorageId: [],                 // 已使用過的藥倉
  //
  medicationCount: {},                      // 根據藥種計算數量
};

const mutations = {
  /**
   * reset all the state.
   * @param {*} state drugInDevice.state
   */
  [Mutations.RESET_DRUG_IN_DEVICE_MODULE](state) {
    state.selectedDrugInDevice = {};
    state.selectedDrugInDeviceID = [];
    state.sortedSelectedDrugInDevice = [];
    state.sortedSelectedDrugInDeviceIndex = 0;
    state.currentDrugInDevice = null;
    state.drugInDeviceList = [];
    state.copyDrugInDeviceList = [];
    state.drugInDeviceLowStockList = [];
    state.expiredDrugInDevice = [];
    state.filterDrugInDeviceList = [];
    state.RefillDrugInDeviceList = [];
    state.nextDrugInDevice = null;
    state.DrugStorageWithSameDrug = {};
    state.expiredDrugCount = 0;
    state.storageErrorCount = 0;
    state.graduallyExpiredDrugCount = 0;
    state.storageError = [];
    state.hasUsedDrugStorageId = [];
  },
  [Mutations.SET_DRUG_IN_DEVICE_LIST](state, drugInDeviceList) {
    // sort the list according to device position.
    const list = drugInDeviceList.length > 0 ? _.sortBy(drugInDeviceList,
      ['device.net.id', 'device.net.row_id', 'device.pos_row', 'device.relative_col']) : [];
    state.drugInDeviceList = list;
    state.copyDrugInDeviceList = list;
    state.filterDrugInDeviceList = list;
  },
  [Mutations.SELECT_DRUG_IN_DEVICES_FROM_SELECTED](state, drugInDeviceId) {
    const drugInDevice = state.allDrugInDevice[drugInDeviceId];
    if (state.selectedDrugInDevice[drugInDeviceId] === undefined) {
      state.selectedDrugInDevice[drugInDeviceId] = drugInDevice;
    } else {
      delete state.selectedDrugInDevice[drugInDeviceId];
    }
    state.selectedDrugInDeviceID = Object.keys(state.selectedDrugInDevice);

    // sort by device id each selection.
    const unsortedList = Object.values(state.selectedDrugInDevice);
    state.sortedSelectedDrugInDevice = unsortedList.length > 0 ? _.sortBy(
      unsortedList, ['device.net.id', 'device.net.row_id', 'device.pos_row', 'device.relative_col'],
    ) : [];
  },
  [Mutations.SELECT_DRUG_IN_DEVICES_FROM_ALL](state, drugInDeviceId) {
    state.currentDrugInDevice = state.allDrugInDevice[drugInDeviceId];
  },
  [Mutations.SET_CURRENT_DRUG_IN_DEVICE](state, drugInDeviceId) {
    state.currentDrugInDevice = state.allDrugInDevice[drugInDeviceId];
    state.currentDrugInDeviceIndex = state.sortedSelectedDrugInDevice.findIndex(o => o.id === drugInDeviceId); // since the return index start from 1
    console.log('state.currentDrugInDeviceIndex', state.currentDrugInDeviceIndex);
  },
  [Mutations.SET_NEXT_DRUG_IN_DEVICE](state, drugInDeviceId) {
    if (drugInDeviceId === null) {
      state.nextDrugInDevice = null;
    } else {
      state.nextDrugInDevice = state.allDrugInDevice[drugInDeviceId];
    }
  },
  /**
   * filtering function for drugStorage searching.
   * @param {*} state vuex.state
   * @param {Object} payload mode: {'lowstock', 'refill', ''}, searchText: '',
   */
  [Mutations.FILTER_DRUG_IN_DEVICE](state, payload) {
    switch (payload.mode) {
      case 'lowStock':
        state.drugInDeviceList = state.drugInDeviceLowStockList;
        break;
      case 'refill':
        state.drugInDeviceList = state.RefillDrugInDeviceList;
        break;
      case '':
        state.drugInDeviceList = state.copyDrugInDeviceList;
        break;
      default:
        state.drugInDeviceList = state.copyDrugInDeviceList;
    }
    if (payload.searchText !== '') {
      state.filterDrugInDeviceList = _.filter(state.drugInDeviceList, (item) => {
        const hasGenericName = item.medication.generic_name.toLowerCase().indexOf(payload.searchText.toLowerCase()) > -1;
        const hasCGMHNumber = item.medication.CGMH_number.toLowerCase().indexOf(payload.searchText.toLowerCase()) > -1;
        const hasCode = item.medication.code.toLowerCase().indexOf(payload.searchText.toLowerCase()) > -1;
        return hasGenericName || hasCGMHNumber || hasCode;
      });
    } else {
      state.filterDrugInDeviceList = state.drugInDeviceList;
    }
  },
  [Mutations.SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY](state, drugInDeviceListSortedByCustom) {
    // sortedSelectedDrugInDevice were only access in "SELECT_DRUG_IN_DEVICES_FROM_SELECTED"
    state.sortedSelectedDrugInDevice = drugInDeviceListSortedByCustom;
  },
  [Mutations.REMOVE_NEXT_DRUG_IN_DEVICE](state) {
    state.nextDrugInDevice = null;
  },
  [Mutations.DRUG_STORAGE_EVENT_FIRED](state, id) {
    state.drugStorageChangedTime += 1;
    state.drugStorageChangedId = id;
  },
  [Mutations.DRUG_IN_DEVICE_USED](state, id) {
    state.hasUsedDrugStorageId.push(id);
    state.hasUsedDrugStorageId = _.uniq(state.hasUsedDrugStorageId);
  },
};

const actions = {
  // get all drugStorage in database, and filter out gradually/expired drugStorage
  getDrugInDevices({ state, commit, getters, rootState }) {
    // get all drug storage data from server
    return rootState.instance.get('/api/drug-storage/', {
      params: {
        device__net__system: rootState.device.systemId,
      },
    })
      .then((res) => {
        // reset expired list
        const drugStorageListFiltered = [];
        state.expiredDrugInDevice = [];
        // filtering expired data and drugStroage in return/external device.
        res.data.results.forEach((item) => {
          const theExpiredDate = moment(item.expired_date);
          const todayDate = moment();
          const remainExpiredDays = theExpiredDate.diff(todayDate, 'days');

          // count the all the medication
          if (state.medicationCount[item.medication.id] === undefined) state.medicationCount[item.medication.id] = 0;
          state.medicationCount[item.medication.id] += item.stock;

          item.expired = remainExpiredDays < 0;
          item.selected = false;
          state.allDrugInDevice[item.id] = item;
          if (item.device.specific_type === 'return_device' || item.device.specific_type === 'external_device' || item.device.net === null) {
            // pass here;
          } else {
            // get expired drug storage.
            if (remainExpiredDays < 0) {
              state.expiredDrugInDevice.push(item);
            } else {
              // count gradually expired drugstorage.
              if (remainExpiredDays >= 0 && remainExpiredDays < getters.currentSystem.settings.alert_outdated_day) {
                state.graduallyExpiredDrugCount += 1;
              }
              drugStorageListFiltered.push(item);
            }
          }
        });
        // save the filtered list to state.
        commit('SET_DRUG_IN_DEVICE_LIST', drugStorageListFiltered);
      });
  },
  // select all drugStorage in filterDrugInDeviceList
  selectAllDrugStorageAndDevices({ state, rootState, commit }) {
    state.filterDrugInDeviceList.forEach((item) => {
      // update selected value for view.
      item.selected = true;
      // instead of recalling "SELECT_DRUG_IN_DEVICES_FROM_SELECTED", directly handle the state date here for faster procedure.
      state.selectedDrugInDevice[item.id] = item;
      // update selected device attr for view updating.
      rootState.device.allDevices[item.device.id].selected = true;
      rootState.device.selectedDevices[item.device.id] = rootState.device.allDevices[item.device.id];
    });
    state.sortedSelectedDrugInDevice = _.sortBy(Object.values(state.selectedDrugInDevice),
      ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
    rootState.device.selectedDevicesID = Object.keys(rootState.device.selectedDevices);
  },
  // unselect all drugStorage in filterDrugInDeviceList
  unSelectAllDrugStorageAndDevices({ state, rootState, commit }) {
    // update for view
    state.filterDrugInDeviceList.forEach((item) => {
      item.selected = false;
      rootState.device.allDevices[item.device.id].selected = false;
    });
    rootState.device.selectedDevices = {};
    rootState.device.selectedDevicesID = [];
    state.selectedDrugInDevice = {};
    state.selectedDrugInDeviceID = [];
    state.sortedSelectedDrugInDevice = [];
  },
  // 選擇所有含有管制藥物的藥倉
  selectAllRestrainedDrugStorage({ state, rootState, commit }) {
    state.filterDrugInDeviceList.forEach((item) => {
      if (item.medication.restrained_class > 0) {
        // update selected value for view.
        item.selected = true;
        // instead of recalling "SELECT_DRUG_IN_DEVICES_FROM_SELECTED", directly handle the state date here for faster procedure.
        state.selectedDrugInDevice[item.id] = item;
        // update selected device attr for view updating.
        rootState.device.allDevices[item.device.id].selected = true;
        rootState.device.selectedDevices[item.device.id] = rootState.device.allDevices[item.device.id];
      }
    });
    state.sortedSelectedDrugInDevice = _.sortBy(Object.values(state.selectedDrugInDevice),
      ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
    rootState.device.selectedDevicesID = Object.keys(rootState.device.selectedDevices);
  },
  // 選擇所有含有非管制藥的藥倉
  selectAllNormalDrugStorage({ state, rootState, commit }) {
    state.filterDrugInDeviceList.forEach((item) => {
      if (item.medication.restrained_class === 0) {
        // update selected value for view.
        item.selected = true;
        // instead of recalling "SELECT_DRUG_IN_DEVICES_FROM_SELECTED", directly handle the state date here for faster procedure.
        state.selectedDrugInDevice[item.id] = item;
        // update selected device attr for view updating.
        rootState.device.allDevices[item.device.id].selected = true;
        rootState.device.selectedDevices[item.device.id] = rootState.device.allDevices[item.device.id];
      }
    });
    state.sortedSelectedDrugInDevice = _.sortBy(Object.values(state.selectedDrugInDevice),
      ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
    rootState.device.selectedDevicesID = Object.keys(rootState.device.selectedDevices);
  },
  // 根據類別選擇藥倉
  selectDrugStorageByGroupId({ state, rootState, commit }, groupId) {
    state.filterDrugInDeviceList.forEach((item) => {
      if (item.medication.group.indexOf(groupId) !== -1) {
        // update selected value for view.
        item.selected = true;
        // instead of recalling "SELECT_DRUG_IN_DEVICES_FROM_SELECTED", directly handle the state date here for faster procedure.
        state.selectedDrugInDevice[item.id] = item;
        // update selected device attr for view updating.
        rootState.device.allDevices[item.device.id].selected = true;
        rootState.device.selectedDevices[item.device.id] = rootState.device.allDevices[item.device.id];
      }
    });
    state.sortedSelectedDrugInDevice = _.sortBy(Object.values(state.selectedDrugInDevice),
      ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
    rootState.device.selectedDevicesID = Object.keys(rootState.device.selectedDevices);
  },
  // 選擇藥倉
  selectDrugInDevice({ dispatch, commit, state, getters }, payload) {
    if (payload.singleSelection && state.sortedSelectedDrugInDevice.length > 0) {
      state.sortedSelectedDrugInDevice.forEach((item) => {
        item.selected = !item.selected;
        commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', item.id);
      });
    }
    // check other drugStorage exist in this device and compare there status
    const drugInDevice = state.drugInDeviceList[payload.num];
    drugInDevice.selected = !drugInDevice.selected;
    commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', drugInDevice.id);

    let isDeviceSelected = false;
    state.sortedSelectedDrugInDevice.forEach((item) => {
      if (item.device.id === drugInDevice.device.id) {
        isDeviceSelected = isDeviceSelected || item.selected;
      }
    });

    const deviceContained = getters.allDevices[drugInDevice.device.id];
    if (deviceContained.selected !== isDeviceSelected) {
      commit('ADD_DEVICE_TO_SELECTED_LIST', drugInDevice.device.id);
    }
  },
  // 根據位置選擇藥倉
  selectDrugInDeviceByPosSelection({ state, commit, getters, dispatch }, payload) {
    commit('ADD_DEVICE_TO_SELECTED_LIST', payload.deviceId);
    const deviceClicked = getters.allDevices[payload.deviceId];
    // ...deviceClicked.drugstorage_set
    // update view, unify the drugStorage selected status as same as device.
    state.drugInDeviceList.forEach((item) => {
      if (item.device.id === payload.deviceId) {
        if (item.selected !== deviceClicked.selected) {
          item.selected = deviceClicked.selected;
          commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', item.id);
        }
      }
    });
  },
  /**
   * set currentDrugAndDevice from the head of drugStorage list
   * @param {*} param0 vuex attribute
   */
  async fromFirstDrugInDevice({ commit, state, dispatch }) {
    console.log('fromFirstDrugInDevice');
    state.sortedSelectedDrugInDeviceIndex = 0;
    await dispatch('setCurrentDrugAndDevice', state.sortedSelectedDrugInDeviceIndex);
  },
  /**
   * set next drugStorage
   * @param {*} param0 vuex attribute
   */
  async toNextDrugInDevice({ commit, state, dispatch }) {
    console.log('toNextDrugInDevice');
    state.sortedSelectedDrugInDeviceIndex += 1;
    await dispatch('setCurrentDrugAndDevice', state.sortedSelectedDrugInDeviceIndex);
  },
  /**
   * set current device and current drugStorage
   * @param {*} param0 vuex attribute
   * @param {*} index index of selectedDrugInDevice key
   */
  async setCurrentDrugAndDevice({ commit, dispatch, state, rootState }, index) {
    const drugInDevice = state.sortedSelectedDrugInDevice[index];
    console.log('setCurrentDrugAndDevices', index, drugInDevice);
    commit('SET_CURRENT_DRUG_IN_DEVICE', drugInDevice.id);

    // update druginfo
    await dispatch('setDrug', drugInDevice.medication.id);

    dispatch('getDrugInDevicesWithSameDrug', drugInDevice.medication.id);
    commit('SET_CURRENT_DEVICE_FROM_ALL', drugInDevice.device.id);
    // set next drugStorage and its device.
    if (state.currentDrugInDeviceIndex !== -1 && (state.currentDrugInDeviceIndex + 1) <= (state.sortedSelectedDrugInDevice.length - 1)) {
      console.log('state.currentDrugInDeviceIndex', state.currentDrugInDeviceIndex);
      commit('SET_NEXT_DRUG_IN_DEVICE', state.sortedSelectedDrugInDevice[state.currentDrugInDeviceIndex + 1].id);
      commit('SET_NEXT_DEVICE', state.nextDrugInDevice.device.id);
    } else {
      commit('REMOVE_NEXT_DRUG_IN_DEVICE');
      commit('REMOVE_NEXT_DEVICE');
    }
  },
  // 更新操作的藥倉資料
  updateCurrentDrugInDevice({ state, dispatch, rootState }, drugInDeviceId) {
    console.log('updateCurrentDrugInDevice', drugInDeviceId);
    return rootState.instance.get(`/api/drug-storage/${drugInDeviceId}`)
    .then((res) => {
      state.allDrugInDevice[drugInDeviceId] = res.data;
      state.currentDrugInDevice = res.data;
      state.currentDrugInDeviceIndex = state.sortedSelectedDrugInDevice.findIndex(o => o.id === drugInDeviceId); // since the return index start from 1
      console.log('state.currentDrugInDeviceIndex', state.currentDrugInDeviceIndex);
      dispatch('getTotalDrugAmountInstanly', state.currentDrugInDevice.medication.id);
    });
  },
  // 取得所有同藥種的藥倉
  getDrugInDevicesWithSameDrug({ commit, state, getters, rootState }, medId) {
    console.log('dispatch getDrugInDeviceWithSameDrug');
    return new Promise((resolve, reject) => {
      console.log('dispath drug in device');
      state.DrugStorageWithSameDrug = {}; // empty the data
      state.DrugStorageWithSameDrugID = [];
      let drugStorageSameMed = _.filter(getters.drugInDeviceList, (item) => {
        return item.medication.id === medId && item.stock > 0;
      });
      // sort the list by expired_date and has_piece, 領藥條件： 最接近過期 > 散裝量最多
      //drugStorageSameMed = _.orderBy(drugStorageSameMed, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
      //20190524
      // sort the list by expired_date and has_piece, 領藥條件： 最接近過期 > 散裝量最小
      drugStorageSameMed = _.orderBy(drugStorageSameMed, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'asc']);
      drugStorageSameMed.forEach((item) => {
        state.DrugStorageWithSameDrug[item.id] = item;
        state.DrugStorageWithSameDrugID.push(item.id);
      });
      console.log(drugStorageSameMed);
      resolve();
    });
  },
  // 取得所有補藥規劃的藥倉
  getRefillOrder({ commit, rootState, state }) {
    return rootState.instance.get('/api/refill-order/', {
      params: {
        drug_storage__device__net__system: rootState.device.systemId,
      },
    }).then((res) => {
      state.RefillDrugInDeviceList = [];
      res.data.forEach((item) => {
        const drugStorage = item.drug_storage;
        drugStorage.selected = false;
        drugStorage.refillId = item.id;
        state.RefillDrugInDeviceList.push(drugStorage);
      });
    });
  },
  // 取得所有低於安全存量的藥倉
  getLowStockDrugInDevice({ state, rootState }) {
    state.drugInDeviceLowStockList = [];
    return rootState.instance.get('/api/low-stock-drug-storage/', {
      params: {
        device__net__system: rootState.device.systemId,
      },
    })
    .then((res) => {
      res.data.forEach((item) => {
        item.selected = false;
        const theExpiredDate = moment(item.expired_date);
        const todayDate = moment();
        const remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
        if (remainExpiredDays >= 0) {
          state.drugInDeviceLowStockList.push(item);
        }
      });
    });
  },
};


const getters = {
  selectedDrugInDeviceID: (state, getters) => {
    return state.selectedDrugInDeviceID;
  },
  currentDrugInDevice: (state, getters) => {
    return state.currentDrugInDevice;
  },
  hasUsedDrugStorageId: (state, getters) => {
    return state.hasUsedDrugStorageId;
  },
  storageError: (state, getters) => {
    return state.storageError;
  },
  drugInDeviceList: (state) => {
    return state.drugInDeviceList;
  },
  DrugStorageWithSameDrugID: (state) => {
    return state.DrugStorageWithSameDrugID;
  },
  drugStorageChangeTime: (state) => {
    return state.drugStorageChangeTime;
  },
};


const store = {
  state,
  mutations,
  actions,
  getters,
};

export default store;



// WEBPACK FOOTER //
// ./src/vuex/module/drugInDevice.js